module.exports = __webpack_public_path__ + "img/icon-chem-spider.24f4bb08.svg";